const { debounce } = require('lodash');

const CategorySelectionList = require('../categories/category-selection-list');

class CategoryHeaderController {
    constructor($scope, $timeout, settings, categoriesService, shopPageStateService, moveFocus) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.settings = settings;
        this.categoriesService = categoriesService;
        this.shopPageStateService = shopPageStateService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.categoriesService.getAll();

        this.selectedCategories = new CategorySelectionList();

        this.$scope.$on('$stateChangeStart', () => this.closeMenu());

        this.onMouseenterDepartment = debounce(
            department => this.$scope.$apply(() => this.selectDepartment(department)),
            this.settings.pies ? this.settings.pies.overlayOnHoverDelay : 150,
            { leading: false, trailing: true },
        );
    }

    onMouseleaveDepartment() {
        this.onMouseenterDepartment.cancel();
    }

    onTouchDepartment(department) {
        this.toggleMenu(department);
    }

    onKeydownDepartment(department, $event) {
        // space or enter
        if ($event.which === 32 || $event.which === 13) {
            $event.preventDefault();
            this.toggleMenu(department);
        }
    }

    selectDepartment(department) {
        // If we are opening the menu for the page we are currently on, we use the
        // selected categories so we can highlight the current page category.
        this.selectedCategories = this.categoriesService.currentCategories.department === department
            ? this.categoriesService.currentCategories.clone()
            : new CategorySelectionList(this.categoriesService.getCategoryTree(department.NodeId));

        this.shopPageStateService.toggleBodyScroll(false);

        this.moveFocus('.categoryHeader-menuHeaderLink:first-of-type');
    }

    selectCategory(category) {
        this.selectedCategories = new CategorySelectionList(this.categoriesService.getCategoryTree(category.NodeId));

        this.moveFocus('._subCategoryNav .categoriesNavigation-link:first-of-type');
    }

    onKeydownHeader($event) {
        // escape
        if ($event.which === 27) {
            this.moveFocus('._departmentNav .categoryHeader-navigationLink.is-active', true);
            this.closeMenu();
        }
    }

    toggleMenu(department) {
        if (this.isMenuOpen && this.selectedCategories.department === department) {
            this.closeMenu();
        } else {
            this.selectDepartment(department);
        }
    }

    closeMenu() {
        this.selectedCategories = new CategorySelectionList();
        this.shopPageStateService.toggleBodyScroll(true);
    }

    isActiveDepartment(department) {
        return department === (this.selectedCategories.department || this.categoriesService.currentCategories.department);
    }

    get isMenuOpen() {
        return this.selectedCategories.hasSelectedCategories;
    }
}

const categoryHeaderComponentDefinition = {
    transclude: true,
    controller: ['$scope', '$timeout', 'Settings', 'CategoriesService', 'ShopPageStateService', 'MoveFocus', CategoryHeaderController],
    template: require('./category-header.component.html').trim(),
};

module.exports = {
    CategoryHeaderController,
    categoryHeaderComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/category-header.component.js